import React, { ReactElement } from "react";
import { styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Routes, Route, useNavigate } from "react-router-dom";
import { RequireAuth } from "../auth/RequireAuth";
import { RequireAdmin } from "../auth/RequireAdmin";
import { Box, Button } from "@mui/material";
import { AdminDashboard } from "../features/admin/AdminDashboard";
import { AdminUsers } from "../features/admin/AdminUsers";
import { AdminFeedback } from "../features/admin/AdminFeedback";
import { AdminMenu } from "./AdminMenu";

const RootContainer = styled(Box)({
  flexGrow: 1,
});

const TitleTypography = styled(Typography)({
  flexGrow: 1,
});

export default function AdminApp(): ReactElement {
  const navigate = useNavigate();

  return (
    <RootContainer>
      <AppBar position="sticky" enableColorOnDark color="primary">
        <Toolbar>
          <TitleTypography variant="h6">
            Planning Poker Admin
          </TitleTypography>
          <Button 
            color="inherit" 
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            Back to App
          </Button>
          <AdminMenu />
        </Toolbar>
      </AppBar>

      <Routes>
        <Route path="/admin" element={
          <RequireAuth>
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          </RequireAuth>
        } />
        <Route path="/admin/users" element={
          <RequireAuth>
            <RequireAdmin>
              <AdminUsers />
            </RequireAdmin>
          </RequireAuth>
        } />
        <Route path="/admin/feedback" element={
          <RequireAuth>
            <RequireAdmin>
              <AdminFeedback />
            </RequireAdmin>
          </RequireAuth>
        } />
      </Routes>
    </RootContainer>
  );
}
